<template>

    <div class="o-productGrid">

        <h3>{{ getKategoriaNazov }} pre tvoju kravičku</h3>

        <div v-if="obchod[0]" class="m-productGrid__list" :class="sizeByCategory">

            <obchod-product-item
                    v-for="(item, index) in obchod.filter(checkCategory)"
                    :key="index"
                    :index="index"
                    :item="item"
                    @buyProduct="$emit('buyProduct', obchod.indexOf(item), item)"
            ></obchod-product-item>

        </div>

    </div>

</template>



<script>
    import ObchodProductItem from './ObchodProductItem.vue'
    export default {
        components: {
            ObchodProductItem
        },
        props: [
            'obchod',
            'kategoria'
        ],
        mounted() {
        },
        methods: {
            checkCategory: function (value) {
                return value.herny_produkt_kategoria === this.kategoria
            },
        },
        computed: {
            getKategoriaNazov: function () {
                switch (this.kategoria) {
                    case 'food':
                        return "Jedlo";
                    case 'drink':
                        return "Pitie";
                    case 'cleanness':
                        return "Čistota";
                    case 'background':
                        return "Pozadia";
                    default:
                        return "Vecičky";
                }
            },
            sizeByCategory: function () {
                if ( this.kategoria !== 'background' ) {
                    return '--small'
                }
                else {
                    return '--medium'
                }
            }
        }
    }
</script>